import styled, { css } from 'styled-components';
import { Box } from '../Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
var Image = styled(Box).withConfig({
  componentId: "sc-1yj95wv-0"
})(["flex:0 1 auto;"]);
Image.displayName = "Media.Image";
var Body = styled(Box).withConfig({
  componentId: "sc-1yj95wv-1"
})(["flex:1 1 auto;"]);
Body.displayName = "Media.Body";
var Media = styled(Box).withConfig({
  componentId: "sc-1yj95wv-2"
})(["display:flex;flex-direction:", ";align-items:", ";", " & &{padding-top:", ";}", "{", " ", " &:only-child{margin:0;}", "}"], function (_ref) {
  var isReversed = _ref.isReversed;
  return isReversed ? "row-reverse" : "row";
}, function (_ref2) {
  var align = _ref2.align,
      isStacked = _ref2.isStacked;
  return !isStacked && align;
}, function (_ref3) {
  var isStacked = _ref3.isStacked,
      isReversed = _ref3.isReversed;
  return isStacked && css(["flex-direction:", ";align-items:center;"], isReversed ? "column-reverse" : "column");
}, function (_ref4) {
  var gutter = _ref4.gutter;
  return gutter && spacing(gutter);
}, Body, function (_ref5) {
  var gutter = _ref5.gutter,
      isStacked = _ref5.isStacked,
      isReversed = _ref5.isReversed;

  if (isStacked) {
    return;
  }

  if (isReversed) {
    return css(["&:first-child{margin-left:", ";}&:last-child{margin-right:", ";}"], gutter && spacing(gutter), gutter && spacing(gutter));
  } else {
    return css(["&:first-child{margin-right:", ";}&:last-child{margin-left:", ";}"], gutter && spacing(gutter), gutter && spacing(gutter));
  }
}, function (_ref6) {
  var gutter = _ref6.gutter,
      isStacked = _ref6.isStacked,
      isReversed = _ref6.isReversed;

  if (!isStacked) {
    return;
  }

  if (isReversed) {
    return css(["&:first-child{margin-top:", ";}&:last-child{margin-bottom:", ";}"], gutter && spacing(gutter), gutter && spacing(gutter));
  } else {
    return css(["&:first-child{margin-bottom:", ";}&:last-child{margin-top:", ";}"], gutter && spacing(gutter), gutter && spacing(gutter));
  }
}, function (_ref7) {
  var isStacked = _ref7.isStacked;
  return isStacked && css(["display:flex;flex-direction:column;align-items:center;"]);
});
export { Body, Image, Media };